// Images for quick links (replace these with your actual image paths)
import BookSessionsImage from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-fuck-off.jpg';
import OnlineServicesImage from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-amazig-lingerie.jpg';
import AboutMeImage from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-amazing.jpg';
import SubApplicationImage from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-big-ass-with-whip.jpg';
import {
  ABOUT_PAGE_URL,
  APPLICATION_PAGE_URL,
  CONTACT_PAGE_URL,
  SESSIONS_PAGE_URL,
} from '../Constants';

export const pagesDataArray = [
  {
    pageName: 'Book Sessions',
    description: 'Ready to kneel? Schedule real-time or online sessions now.',
    pageUrl: CONTACT_PAGE_URL,
    imageUrl: BookSessionsImage,
  },
  {
    pageName: 'Online Services',
    description:
      'Exclusive digital domination, custom content, and distance training.',
    pageUrl: SESSIONS_PAGE_URL,
    imageUrl: OnlineServicesImage,
  },
  {
    pageName: 'About Me',
    description: 'Get to know your favorite nightmare: King Liyah Minx.',
    pageUrl: ABOUT_PAGE_URL,
    imageUrl: AboutMeImage,
  },
  {
    pageName: 'Sub Application',
    description: 'Prove your worth. Apply for consideration to serve.',
    pageUrl: APPLICATION_PAGE_URL,
    imageUrl: SubApplicationImage,
  },
];
